(function () {
  var root = document.getElementById('returns-request-form');
  if (!root) return;

  var form = root.querySelector('#ReturnsRequestForm');
  if (!form) return;

  var productSelect = form.querySelector('#ReturnsProduct');
  var reasonSelect = form.querySelector('#ReturnsWhatHappened');
  var productOther = form.querySelector('[data-field="product-other"]');
  var reasonOther = form.querySelector('[data-field="reason-other"]');
  var photoField = form.querySelector('[data-field="photo"]');
  var lotField = form.querySelector('[data-field="lot"]');
  var photoInput = form.querySelector('#ReturnsPhoto');
  var photoData = form.querySelector('#ReturnsPhotoData');
  var photoName = form.querySelector('#ReturnsPhotoName');
  var fileStatus = form.querySelector('[data-file-status]');
  var bodyField = form.querySelector('#ReturnsRequestBody');
  var MAX_BYTES = 5 * 1024 * 1024;
  var MAX_DATA_URL = 900000;

  function setVisible(field, visible) {
    if (!field) return;
    var input = field.querySelector('[data-conditional-input], input, textarea, select');
    field.hidden = !visible;
    field.classList.toggle('is-hidden', !visible);
    if (input) {
      if (visible) {
        if (input.type !== 'file') input.setAttribute('required', 'required');
      } else {
        input.removeAttribute('required');
        if (input.type === 'file') {
          input.value = '';
          if (photoData) photoData.value = '';
          if (photoName) photoName.value = '';
          if (fileStatus) {
            fileStatus.hidden = true;
            fileStatus.textContent = '';
            fileStatus.classList.remove('is-error');
          }
        } else if (input.type !== 'radio') {
          input.value = '';
        }
      }
    }
  }

  function syncConditionals() {
    var product = productSelect ? productSelect.value : '';
    var reason = reasonSelect ? reasonSelect.value : '';
    var needsPhoto = reason === 'Damaged/defective' || reason === 'Wrong item received';
    var needsLot = reason === 'Damaged/defective' || reason === 'Reaction/sensitivity';

    setVisible(productOther, product === 'Other');
    setVisible(reasonOther, reason === 'Other (specify)');
    setVisible(photoField, needsPhoto);
    setVisible(lotField, needsLot);

    if (photoInput) {
      if (needsPhoto) photoInput.setAttribute('required', 'required');
      else photoInput.removeAttribute('required');
    }
  }

  function setFileStatus(message, isError) {
    if (!fileStatus) return;
    fileStatus.hidden = !message;
    fileStatus.textContent = message || '';
    fileStatus.classList.toggle('is-error', !!isError);
  }

  function readFileAsDataURL(file) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  function compressImage(file) {
    return readFileAsDataURL(file).then(function (dataUrl) {
      if (typeof dataUrl !== 'string' || dataUrl.length <= MAX_DATA_URL) {
        return { dataUrl: dataUrl, name: file.name };
      }

      return new Promise(function (resolve, reject) {
        var img = new Image();
        img.onload = function () {
          var canvas = document.createElement('canvas');
          var maxEdge = 1600;
          var scale = Math.min(1, maxEdge / Math.max(img.width, img.height));
          canvas.width = Math.max(1, Math.round(img.width * scale));
          canvas.height = Math.max(1, Math.round(img.height * scale));
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          var quality = 0.8;
          var compressed = canvas.toDataURL('image/jpeg', quality);
          while (compressed.length > MAX_DATA_URL && quality > 0.4) {
            quality -= 0.1;
            compressed = canvas.toDataURL('image/jpeg', quality);
          }

          if (compressed.length > MAX_DATA_URL) {
            reject(new Error('Photo is too large to attach. Please upload a smaller image.'));
            return;
          }

          resolve({
            dataUrl: compressed,
            name: file.name.replace(/\.\w+$/, '') + '.jpg'
          });
        };
        img.onerror = function () {
          reject(new Error('Could not read that image. Please try another file.'));
        };
        img.src = dataUrl;
      });
    });
  }

  function buildBody() {
    var name = (form.querySelector('#ReturnsFirstLastName') || {}).value || '';
    var email = (form.querySelector('#ReturnsEmail') || {}).value || '';
    var orderNumber = (form.querySelector('#ReturnsOrderNumber') || {}).value || '';
    var product = productSelect ? productSelect.value : '';
    var productOtherValue = (form.querySelector('#ReturnsProductOther') || {}).value || '';
    var reason = reasonSelect ? reasonSelect.value : '';
    var reasonOtherValue = (form.querySelector('#ReturnsReasonOther') || {}).value || '';
    var resolution = (form.querySelector('input[name="contact[Preferred Resolution]"]:checked') || {}).value || '';
    var more = (form.querySelector('#ReturnsMoreInfo') || {}).value || '';
    var lot = (form.querySelector('#ReturnsLotNumber') || {}).value || '';
    var lines = [
      'Returns Request',
      'Name: ' + name,
      'Email: ' + email,
      'Order Number: ' + orderNumber,
      'Product: ' + (product === 'Other' ? productOtherValue || 'Other' : product),
      'What happened: ' + (reason === 'Other (specify)' ? reasonOtherValue || 'Other' : reason),
      'Preferred resolution: ' + resolution,
      'Lot Number: ' + (lot || 'N/A'),
      'Photo filename: ' + ((photoName && photoName.value) || 'N/A'),
      'Additional details: ' + (more || 'N/A')
    ];
    return lines.join('\n');
  }

  if (productSelect) productSelect.addEventListener('change', syncConditionals);
  if (reasonSelect) reasonSelect.addEventListener('change', syncConditionals);

  if (photoInput) {
    photoInput.addEventListener('change', function () {
      var file = photoInput.files && photoInput.files[0];
      photoData.value = '';
      photoName.value = '';
      setFileStatus('', false);

      if (!file) return;

      if (file.size > MAX_BYTES) {
        photoInput.value = '';
        setFileStatus('Please choose an image under 5MB.', true);
        return;
      }

      setFileStatus('Preparing photo…', false);
      compressImage(file)
        .then(function (result) {
          photoData.value = result.dataUrl;
          photoName.value = result.name;
          setFileStatus('Photo ready: ' + result.name, false);
        })
        .catch(function (err) {
          photoInput.value = '';
          setFileStatus(err.message || 'Could not process photo.', true);
        });
    });
  }

  form.addEventListener('submit', function (event) {
    syncConditionals();

    var reason = reasonSelect ? reasonSelect.value : '';
    var needsPhoto = reason === 'Damaged/defective' || reason === 'Wrong item received';
    if (needsPhoto && (!photoData || !photoData.value)) {
      event.preventDefault();
      setFileStatus('Please upload a photo before sending your request.', true);
      if (photoInput) photoInput.focus();
      return;
    }

    if (bodyField) bodyField.value = buildBody();
  });

  syncConditionals();
})();
